import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TableSearchState {
    tableId: string | null;
    searchString: string;
}

const initialState: TableSearchState = {
    tableId: null,
    searchString: "",
};

const tableSearchSlice = createSlice({
    name: "tableSearch",
    initialState,
    reducers: {
        setSearchFilter: (state, action: PayloadAction<{ tableId: string; searchString: string }>) => {
            state.tableId = action.payload.tableId;
            state.searchString = action.payload.searchString;
        },
        clearSearchFilter: (state) => {
            state.tableId = null;
            state.searchString = "";
        },
    },
});

export const { setSearchFilter, clearSearchFilter } = tableSearchSlice.actions;
export default tableSearchSlice.reducer;
